import { render, staticRenderFns } from "./CreateSolicitud.vue?vue&type=template&id=70b0f2ee&"
import script from "./CreateSolicitud.vue?vue&type=script&lang=js&"
export * from "./CreateSolicitud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports